export type CheckablePeriodUnitType = 'WITHIN_DAY' | 'WITHIN_WEEK' | 'WITHIN_MONTH' | 'WITHIN_YEAR';
export type CheckDecisionChoiceUnitType = 'NONE' | 'APPROVE' | 'DISAPPROVE' | 'PENDING';
export type SearchCreditType = 'UNSELECTED' | 'DOWNLOADED' | 'MANUAL_UPLOADED';
export type RiskLevelScoreType = 'HIGH' | 'MIDDLE' | 'LOW' | 'NONE' | 'EXCLUDE';
export type SearchDateType = 'ALL' | 'UNIT' | 'DATE';
export type ReflectionType = 'ALL' | 'FOLDER' | 'CHECKED_AT';
export type DateUnitType = 'DAY' | 'WEEK' | 'MONTH' | 'YEAR';
export type ExecuteType =
  | 'GOOGLE_SEARCH'
  | 'NEWSPAPER_SEARCH'
  | 'CREDIT_MANAGEMENT_SEARCH'
  | 'CREDIT_MANAGEMENT_DOWNLOAD'
  | 'WORLD_CHECK'
  | 'REGISTRY_SEARCH'
  | 'BANKRUPT_SEARCH'
  | 'SPN_SEARCH'
  | 'AI_CREDIT'
  | 'AI_REPORT_CREATE';

export type ExecuteStatusType =
  | 'PENDING'
  | 'IS_EXECUTING'
  | 'IS_FINISHED'
  | 'NON_DISPLAY'
  | 'IS_ANALYZING'
  | 'ERROR'
  | 'SUSPENDED'
  | 'SQS_MESSAGING_ERROR';

export type FileStatusType =
  | 'CREATED'
  | 'CREATING'
  | 'FAILED'
  | 'SAVED'
  | 'DELETED'
  | 'BPO_CREATING'
  | 'BPO_CREATED'
  | 'BPO_FAILED'
  | 'BPO_SAVED'
  | 'DEEP_ARCHIVE_RESTORING'
  | 'DEEP_ARCHIVE_RESTORED'
  | 'DEEP_ARCHIVE_RESTORE_FAILED';

export type FileType =
  | 'SUMMARY'
  | 'EXCEL'
  | 'REPORT'
  | 'SPN'
  | 'SPN_INDIVIDUAL'
  | 'CSV'
  | 'AI_CREDIT';

export type ApiAuthInformationKindType = 'G_SEARCH';

export type DuplicateType = 'INSERT' | 'UPDATE' | 'NOT';

export type TargetProfileType = 'ALL' | 'TDB' | 'TSR' | 'RMG';

export const code = {
  registry_status: {
    not_registered: 0,
    registry_in_progress: 1,
    registered: 2,
    registry_error: 3,
    extracting: 4,
    extracted: 5,
    extracted_error: 6,
    upload_extraction_possible: 7,
    upload_extraction_impossible: 8,
    not_data: 9,
    multiple_choices: 11,
  },
  extraction_format: {
    automatic: 0,
    manual: 2,
  },
  date_unit: {
    day: 'DAY',
    week: 'WEEK',
    month: 'MONTH',
    year: 'YEAR',
  },
  checkable_period_unit: {
    day: 'WITHIN_DAY',
    week: 'WITHIN_WEEK',
    month: 'WITHIN_MONTH',
    year: 'WITHIN_YEAR',
  },
  check_decision_choice_unit: {
    none: 'NONE',
    approve: 'APPROVE',
    disapprove: 'DISAPPROVE',
    pending: 'PENDING',
  },
  risk_level_score_unit: {
    high: 'HIGH',
    middle: 'MIDDLE',
    low: 'LOW',
    none: 'NONE',
    exclude: 'EXCLUDE',
  },
  execute_status_unit: {
    pending: 'PENDING',
    is_executing: 'IS_EXECUTING',
    is_finished: 'IS_FINISHED',
    non_display: 'NON_DISPLAY',
    is_analyzing: 'IS_ANALYZING',
    error: 'ERROR',
    suspended: 'SUSPENDED',
    sqs_messaging_error: 'SQS_MESSAGING_ERROR',
  },
  search_date_type_unit: {
    all: 'ALL',
    unit: 'UNIT',
    date: 'DATE',
  },
  reflection_type_unit: {
    all: 'ALL',
    folder: 'FOLDER',
    checked_at: 'CHECKED_AT',
  },
  file_status_type_unit: {
    created: 'CREATED',
    creating: 'CREATING',
    failed: 'FAILED',
    saved: 'SAVED',
    deleted: 'DELETED',
    bpo_creating: 'BPO_CREATING',
    bpo_created: 'BPO_CREATED',
    bpo_failed: 'BPO_FAILED',
    bpo_saved: 'BPO_SAVED',
    deep_archive_restoring: 'DEEP_ARCHIVE_RESTORING',
    deep_archive_restored: 'DEEP_ARCHIVE_RESTORED',
    deep_archive_restore_failed: 'DEEP_ARCHIVE_RESTORE_FAILED',
  },
  duplicate_unit: {
    insert: 'INSERT',
    update: 'UPDATE',
    not: 'NOT',
  },
  caution_classification_unit: {
    one: 1,
    two: 2,
    three: 3,
    four: 4,
  },
  target_profile_unit: {
    all: 'ALL',
    tdb: 'TDB',
    tsr: 'TSR',
    rmg: 'RMG',
  },
};

export const codeConverter = {
  registry_status: {
    0: '登記未取得',
    1: '登記取得中',
    2: '登記取得済',
    3: '登記エラー',
    4: '抽出中',
    5: '抽出済み',
    6: '抽出エラー',
    7: '抽出可',
    8: '抽出不可',
    9: '登記なし',
    11: '複数候補',
  } as Record<string, string>,
  extraction_format: {
    0: '自動',
    2: '手動',
  } as Record<string, string>,
  date_unit: {
    DAY: '日後',
    WEEK: '週後',
    MONTH: 'か月後',
    YEAR: '年後',
  },
  checkable_period_unit: {
    WITHIN_DAY: '日以内',
    WITHIN_WEEK: '週間以内',
    WITHIN_MONTH: 'か月以内',
    WITHIN_YEAR: '年以内',
  },
  checkable_period_unit_short_name: {
    WITHIN_DAY: '日',
    WITHIN_WEEK: '週',
    WITHIN_MONTH: '月',
    WITHIN_YEAR: '年',
  },
  check_decision_choice_unit: {
    NONE: 'ー',
    APPROVE: '承認',
    DISAPPROVE: '否認',
    PENDING: '保留',
  },
  risk_level_score_unit: {
    HIGH: '高',
    MIDDLE: '中',
    LOW: '低',
    NONE: '判定不可',
    EXCLUDE: '解析除外',
  },
  llm_risk_level_score_unit: {
    HIGH: 'リスクLv 高',
    MIDDLE: 'リスクLv 中',
    LOW: 'リスクLv 低',
    NONE: '対象外',
    EXCLUDE: '解析除外',
    NOT_LLM: 'リスクLv',
  },
  execute_status_unit: {
    PENDING: '実行待ち',
    IS_EXECUTING: '実行中',
    IS_FINISHED: '実行終了（正常)',
    NON_DISPLAY: '非表示',
    IS_ANALYZING: '分析中（GoogleSearch）',
    ERROR: 'エラー終了',
    SUSPENDED: '実行中断',
    SQS_MESSAGING_ERROR: 'SQSメッセージングエラー',
  },
  search_date_type_unit: {
    ALL: '全期間',
    UNIT: '単位指定',
    DATE: '日付指定',
  },
  file_status_type_unit: {
    CREATED: 'ファイル作成完了',
    CREATING: 'ファイル作成中',
    FAILED: 'ファイル作成失敗',
    SAVED: '保存済',
    DELETED: '削除済',
    BPO_CREATING: '',
    BPO_CREATED: '',
    BPO_FAILED: '',
    BPO_SAVED: '',
    DEEP_ARCHIVE_RESTORING: '取得中',
    DEEP_ARCHIVE_RESTORED: '取得完了',
    DEEP_ARCHIVE_RESTORE_FAILED: '取得失敗',
  },
  target_profile_unit: {
    ALL: '全て',
    TDB: '帝国データバンク企業情報',
    TSR: '東京商工リサーチ企業情報',
    RMG: 'リスモンG-与信ナビ(企業リスク格付)',
  },
};

export const authCode = {
  authority: {
    OWNER: 1, // オーナー権限
    ALL: 2, // 全権限
    EXECUTE: 3, // チェック実行
    READONLY: 4, // 観覧
  },
  contractType: {
    NET: 1, // ネット
    NET_CREDIT: 2, // ネット、与信
    NET_PAPER_CREDIT: 3, // ネット、新聞検索、与信
    NET_PAPER_CREDIT_NOT_G_SEARCH_KEY: 4, // ネット、新聞検索、与信(g search_keyなし)
  },
  contractUnitType: {
    MONTHLY: 1, // 月間契約プラン：件数（自由）あり
    YEARLY: 2, // 年間契約プラン：件数（自由）あり
    PAY_PER_USE: 3, // 完全従量制：無制限
  },
  paymentType: {
    PAID: 1, // 有償
    TRIAL: 2, // 無償トライアル
    FREEMIUM: 3, // 無償（無償期間超）
  },
  serviceType: {
    COMPLIANCE: 0, // コンプライアンス
    REFERENCE_CHECK: 1, // リファレンスチェック
  },
  serviceKind: {
    ROBOROBO: 1, // RoboRoboユーザー
    SPRS: 2, // SPRSユーザー
  },
};

export const serviceName: { [key: string]: number } = {
  compliance: 0,
  reference: 1,
};

export const entityTypeOptions = [
  { key: '個人', value: 'INDIVIDUAL' },
  { key: '組織', value: 'ORGANISATION' },
];

export const executeWorldCheckOptions = [
  { key: 'しない', value: 'NO' },
  { key: 'する', value: 'YES' },
];

export const genderOptions = [
  { key: '未設定', label: '未設定', value: '' },
  { key: '男性', label: '男性', value: 'MALE' },
  { key: '女性', label: '女性', value: 'FEMALE' },
  { key: 'その他', label: 'その他', value: 'UNSPECIFIED' },
];

export const caseScreeningItem = {
  individual: [
    { label: 'GENDER', displayName: '性別' },
    { label: 'NATIONALITY', displayName: '国籍' },
    { label: 'DATE_OF_BIRTH', displayName: '生年月日' },
    { label: 'PLACE_OF_BIRTH', displayName: '出生地' },
    { label: 'COUNTRY_LOCATION', displayName: '所在国' },
    { label: 'DOCUMENT_ID_TYPE', displayName: '識別番号種別' },
    { label: 'DOCUMENT_ID', displayName: '識別番号' },
  ],
  organisation: [
    { label: 'REGISTERED_COUNTRY', displayName: '登録国' },
    { label: 'DOCUMENT_ID_TYPE', displayName: '識別番号種別' },
    { label: 'DOCUMENT_ID', displayName: '識別番号' },
  ],
};

export type TypeInfo = { code: string; label: string };

export const UNKNOWN: TypeInfo = { code: 'UNKNOWN', label: '分類不明' };

export const typeDefinitions: Array<{ code: string; fullText: string; label: string }> = [
  { code: 'S', fullText: 'Sanctions', label: '制裁' },
  { code: 'SIC', fullText: 'Special Interest Categories', label: '特定犯罪カテゴリー' },
  { code: 'RE', fullText: 'Regulatory Enforcement', label: '規制当局' },
  { code: 'LE', fullText: 'Law Enforcement', label: '司法当局' },
  { code: 'PEP', fullText: 'PEP', label: '公的要人' },
  { code: 'OB', fullText: 'Other Bodies', label: 'その他機関' },
  { code: 'WL', fullText: 'Watchlist', label: '監視対象リスト' },
  { code: 'MC', fullText: 'Media Check', label: 'メディア照合' },
  { code: 'CW', fullText: 'Client Watchlist', label: '顧客監視リスト' },
  { code: 'COUNTRY', fullText: 'Country', label: '国' },
];

export const registerByBulkErrorMessage = {
  NEGATIVE_WORD_REQUIRED: 'ネガティブワードは必須です。',
  NEGATIVE_WORD_LIMIT_OVER: 'ネガティブワードは上限100ワードまでとなります。',
  NEGATIVE_WORD_LIMIT_OVER_UN_LOCKED: 'ネガティブワードは上限500ワードまでとなります。',
  EXCLUDE_WORD_LIMIT_OVER: '除外ワードは上限10ワードまでとなります。',
  CHECKABLE_PERIOD_UNIT:
    'チェック対象期間の指定は、単位指定と日付指定、いずれか片方のみ利用できます。',
  WITH_WORLD_CHECK_ENTITY_TYPE_REQUIRED: 'World Checkを実行する場合は種別の選択が必須です。',
  COUNTRY_LOCATION_REQUIRED: '識別番号種別が入力されている場合は、所在国を入力してください。',
  REGISTERED_COUNTRY_REQUIRED: '識別番号種別が入力されている場合は、登録国を入力してください。',
  DOCUMENT_ID_TYPE_REQUIRED: '識別番号が入力されている場合は、識別番号種別を入力してください。',
  DAY_OF_BIRTH_FORMAT_INVALID: '生年月日はyyyy/mm/ddの形式で入力してください。',
  DOCUMENT_ID_REQUIRED: '識別番号種別が入力されている場合は、識別番号を入力してください。',
  SPN_AGE_OR_YEAR_FORMAT_INVALID: '年齢/生年は4桁以内の数字で入力してください。',
} as const;
